var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'option-button': true,
    selected: _vm.isSelected,
    'is-loading': _vm.isLoading,
    disabled: _vm.disabled || _vm.isLoading,
    'is-clickable': _vm.isClickable,
  },on:{"click":_vm.selectItem}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }